//
// FileService
//      miscellaneous file functions
//
function fileServiceFactory() {

    return {
        getFilePath: function(sampleID) {

            var filePath = "";

            if (!(sampleID === null) && !(sampleID === undefined) && sampleID.length > 5) {

                filePath = sampleID.substring(0, 5);

                if (sampleID.length < 9) {
                    filePath += "/" + sampleID.substring(5, sampleID.length) + "/";
                } else {
                    filePath += "/" + sampleID.substring(5, 9) + "/";
                }
                filePath += sampleID + "/";
            }
            return filePath;
        }
    };
}

export default angular.module("mars.vet.dnareports.services.file", ["ng"]).factory("FileService",fileServiceFactory).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/file.service.js